module.exports = __webpack_public_path__ + "static/media/Shop button.2b0e31e7.png";